import { render, staticRenderFns } from "./addRuleConfig.vue?vue&type=template&id=31e039b4&scoped=true&"
import script from "./addRuleConfig.vue?vue&type=script&lang=js&"
export * from "./addRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./addRuleConfig.vue?vue&type=style&index=0&id=31e039b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e039b4",
  null
  
)

export default component.exports